var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Divider"}},[_c('p',{staticClass:"container"},[_vm._v(_vm._s(_vm.Msg)+"~")])])
}
var staticRenderFns = []

export { render, staticRenderFns }